export default __webpack_public_path__ + "static/media/J240MANB4.6400e0f4.pdf";